import React, { FC } from "react";

interface PictureProps {
  sourceSrc?: string;
  imgSrc?: string;
  alt?: string;
  className?: string;
}

export const Picture: FC<PictureProps> = ({
  sourceSrc,
  imgSrc,
  alt,
  className,
}) => {
  return (
    <picture className={className}>
      <source srcSet={sourceSrc} />
      <img src={imgSrc} alt={alt} />
    </picture>
  );
};
